export const normalizeKey = (key) => key.toLowerCase().replace(/\s+/g, "_");

export const preprocessFormula = (formula, contextKeys = []) => {
    formula = formula.replace(
        /(\b[a-zA-Z_][a-zA-Z0-9_ ]*)\s*([-+])\s*(\d+(\.\d+)?)%/gi,
        (_, variable, operator, percent) => {
            const safeVar = normalizeKey(variable.trim());
            const decimal = parseFloat(percent) / 100;
            return `${safeVar} ${operator} (${safeVar} * ${decimal})`;
        }
    );

    for (const key of contextKeys) {
        const regex = new RegExp(`\\b${key}\\b`, "gi");
        formula = formula.replace(regex, normalizeKey(key));
    }

    return formula;
};

export const normalizeTier = (tier) => ({
    id: tier.id || crypto.randomUUID(),
    name: tier.name?.trim() || "Unnamed",
    formula: tier.formula?.trim() || "",
    price: typeof tier.price === "number" ? tier.price : null
});

export const evaluateTieredFormulas = (inputVariants, basePrice) => {
    const pricingVariants = inputVariants.map(p => ({
        id: p.id || crypto.randomUUID(),
        name: p.name?.trim() || "Unnamed",
        formula: p.formula?.trim() || ""
    }));

    const prices = {};
    const context = { [normalizeKey("base")]: basePrice };
    const skipped = [];

    const tryEvaluate = (variant) => {
        const tierId = variant.id;
        const tierName = variant.name;
        const normalizedTierName = normalizeKey(tierName);
        let formula = variant.formula;

        if (!tierId || !tierName || !formula) return false;

        if (!isNaN(Number(formula))) {
            const value = +Number(formula).toFixed(2);
            prices[tierId] = { id: tierId, name: tierName, price: value };
            context[normalizedTierName] = value;
            return true;
        }

        for (const key in prices) {
            const tier = prices[key];
            context[normalizeKey(tier.name)] = tier.price;
        }

        formula = preprocessFormula(formula, Object.keys(context));

        const usedVars = [...formula.matchAll(/\b[a-zA-Z_][a-zA-Z0-9_]*\b/gi)].map(m => normalizeKey(m[0]));
        const missingVars = usedVars.filter(v => !(v in context));
        if (missingVars.length > 0) return false;

        try {
            // eslint-disable-next-line no-new-func
            const fn = new Function(...Object.keys(context), `return ${formula}`);
            const value = +fn(...Object.values(context)).toFixed(2);
            prices[tierId] = { id: tierId, name: tierName, price: value };
            context[normalizedTierName] = value;
            return true;
        } catch {
            return false;
        }
    };

    for (const variant of pricingVariants) {
        if (!tryEvaluate(variant)) skipped.push(variant);
    }

    for (const variant of skipped) {
        tryEvaluate(variant);
    }

    pricingVariants.forEach(v => {
        if (!(v.id in prices)) {
            prices[v.id] = { id: v.id, name: v.name, price: null };
        }
    });

    return prices;
};